import React from "react";

export const TitleHeading = (props) => {
  const hasHtml = props.title && (props.title.includes('<') || props.title.includes('&lt;'));
  
  return (
    <h2 className={`section-title  ${props.className} font3pc`}>
      {hasHtml ? (
        <span dangerouslySetInnerHTML={{ __html: props.title }} />
      ) : (
        props.title
      )}
    </h2>
  );
};
